module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_lp-data__box-subtitle03-3f4fb256a856e34ae70be5d9de3922c5.png";